export const RECORDER_ORIGIN = "http://127.0.0.1:5180";
export async function readPairingFile(file: File): Promise<string> {
  if (file.size > 4096)
    throw new Error("Choose the recorder-pairing.json file created by the connector.");
  let data: unknown;
  try {
    data = JSON.parse(await file.text());
  } catch {
    throw new Error("Choose the recorder-pairing.json file created by the connector.");
  }
  if (
    !data ||
    typeof data !== "object" ||
    !("version" in data) ||
    data.version !== 1 ||
    !("origin" in data) ||
    data.origin !== RECORDER_ORIGIN ||
    !("token" in data) ||
    typeof data.token !== "string" ||
    !/^[0-9a-f-]{72}$/.test(data.token)
  )
    throw new Error("This pairing file is not valid for the local Anthem recorder.");
  return data.token;
}
export async function localRequest<T>(
  path: string,
  token: string,
  command?: unknown,
): Promise<T> {
  if (!token) throw new Error("Pair this browser with the local recorder first.");
  const options: RequestInit & { targetAddressSpace: "loopback" } = {
    targetAddressSpace: "loopback",
    credentials: "omit",
    method: command ? "POST" : "GET",
    headers: {
      "x-labs-recorder": token,
      ...(command ? { "content-type": "application/json" } : {}),
    },
    body: command ? JSON.stringify(command) : undefined,
    signal: AbortSignal.timeout(command ? 15000 : 5000),
  };
  let response: Response;
  try {
    response = await fetch(RECORDER_ORIGIN + "/api/recorder/" + path, options);
  } catch {
    throw new Error(
      "Could not reach the recorder. Start the connector on this computer, allow local network access, and choose its current pairing file.",
    );
  }
  const data = await response.json();
  if (!response.ok)
    throw new Error(
      typeof data?.error === "string" ? data.error : "Local recorder unavailable.",
    );
  return data as T;
}
